import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { CurrencyInput } from './components/CurrencyInput';
import type { FormData } from '@/context/CalculatorReturnOfInvestment/types';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import * as S from '../../styles';

export function Consultancy() {
	const fieldName: keyof FormData = 'consultancy';
	const { onKeyDown } = useCalculateReturnOfInvestments();

	return (
		<Row justify="center" gutter={[0, 30]} style={{ maxWidth: '80rem' }}>
			<Col span={24} style={{ marginTop: '24px' }}>
				<S.RequiredFormItem
					labelCol={{ span: 24 }}
					label={I18n.get('Consultancy value')}
					name={[fieldName, 'consultancy_value']}
					rules={[{ required: true, message: I18n.get('Please enter the consultancy value.') }]}
					normalize={(value) => (value === '' ? null : value)}
				>
					<CurrencyInput placeholder={I18n.get('Enter consultancy value')} onKeyDown={onKeyDown} />
				</S.RequiredFormItem>
			</Col>
		</Row>
	);
}
